import { ColumnType } from '@datachain/ui-sdk/components/dc-types';
import { castDraft, immerable, produce } from 'immer';

export interface IDepotHeaderMappingItemEntity {
	id: string | number;
	label: string;
	previousLabel: string;
	dataType: ColumnType;
	isList: boolean;
	savedType: ColumnType;
	convertTo: null | ColumnType;
	format: string | null;
	timezone: string | null;
	language: string | null;
	position: number;
}

const entityDefaults: IDepotHeaderMappingItemEntity = {
	id: '-1',
	label: '',
	previousLabel: '',
	dataType: ColumnType.Unknown,
	isList: false,
	savedType: ColumnType.Unknown,
	convertTo: null,
	format: null,
	timezone: null,
	language: null,
	position: -1,
};

export class HeaderMappingItemEntity implements IDepotHeaderMappingItemEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public label = entityDefaults.label;
	public previousLabel = entityDefaults.previousLabel;
	public dataType = entityDefaults.dataType;
	public isList = entityDefaults.isList;
	public savedType = entityDefaults.savedType;
	public convertTo = entityDefaults.convertTo;
	public format = entityDefaults.format;
	public timezone = entityDefaults.timezone;
	public language = entityDefaults.language;
	public position = entityDefaults.position;

	public static build(
		params: Partial<IDepotHeaderMappingItemEntity> = {}
	): HeaderMappingItemEntity {
		const instance = new HeaderMappingItemEntity();
		instance.id = params.id ?? entityDefaults.id;
		instance.previousLabel =
			params.previousLabel ?? entityDefaults.previousLabel;
		instance.dataType = params.dataType ?? entityDefaults.dataType;
		instance.isList = params.isList ?? entityDefaults.isList;
		instance.convertTo = params.convertTo ?? entityDefaults.convertTo;
		instance.format = params.format ?? entityDefaults.format;
		instance.timezone = params.timezone ?? entityDefaults.timezone;
		instance.language = params.language ?? entityDefaults.language;
		instance.position = params.position ?? entityDefaults.position;

		instance.savedType = instance.convertTo
			? instance.convertTo
			: instance.dataType;

		if (params.previousLabel) {
			instance.label = params.previousLabel;
		}

		return instance;
	}

	public setConvertTo(type: ColumnType): HeaderMappingItemEntity {
		return produce(this, (draft: HeaderMappingItemEntity) => {
			draft.convertTo = type;
		});
	}

	public setTransientDataType(type: ColumnType): HeaderMappingItemEntity {
		return produce(this, (draft: HeaderMappingItemEntity) => {
			draft.dataType = type;
		});
	}

	public setFormat(format: string | null): HeaderMappingItemEntity {
		return produce(this, (draft: HeaderMappingItemEntity) => {
			draft.format = format;
		});
	}

	public setTimezone(timezone: string | null): HeaderMappingItemEntity {
		return produce(this, (draft) => {
			draft.timezone = castDraft(timezone);
		});
	}

	public setLanguage(language: string | null): HeaderMappingItemEntity {
		return produce(this, (draft) => {
			draft.language = castDraft(language);
		});
	}

	public setPreviousLabel(label: string): HeaderMappingItemEntity {
		return produce(this, (draft: HeaderMappingItemEntity) => {
			draft.previousLabel = label;
		});
	}

	public setLabel(label: string): HeaderMappingItemEntity {
		return produce(this, (draft: HeaderMappingItemEntity) => {
			draft.label = label;
		});
	}

	public setPosition(position: number): HeaderMappingItemEntity {
		return produce(this, (draft: HeaderMappingItemEntity) => {
			draft.position = position;
		});
	}

	public setIsList(isList: boolean): HeaderMappingItemEntity {
		return produce(this, (draft: HeaderMappingItemEntity) => {
			draft.isList = isList;
		});
	}
}
